import styled from 'styled-components';
import { stylesIf, breakpoints } from '../utils/styleHelpers';
import Button from '@veneer/core/dist/scripts/button';
import Accordion from '@veneer/core/dist/scripts/accordion';

export const ReTargetContainer = styled.div`
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  box-sizing: border-box;
  min-height: auto
  overflow: hidden;
  width:100%;
  margin: 0 auto;
  height: 100vh;
  justify-content: space-around;
  padding-top: 1rem;
  padding-left: ${(props) => (props.isDesktop ? '1.5rem' : '0')};
  padding-bottom: 2rem;
  padding-right: ${(props) => (props.isDesktop ? '1.5rem' : '0')};
  font-family: "HP Simplified", Arial, sans-serif;
  direction:${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  &&{
    .vn-animated-height__wrapper-inner>div {
      padding:0.5rem 0;
    }
  }

  @media screen and (min-width:${breakpoints.tablet}) {
    max-width: 64rem;
    margin: 1rem auto 0;
    padding: 2rem 3.5rem;
    height: 100%;
  }

  @media screen and (min-width:500px) and (max-width:500px) and (min-height:530px ) and (max-height:530px) {
    display:flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    box-sizing: border-box;
    min-height: auto
    overflow: hidden;
    width:100%;
    margin-top: 2rem auto;
    height: 100vh;
    justify-content: space-between;
    padding-top: 2rem;
    padding-bottom: 1rem;
    padding-left: 0;
    padding-right: 0;
  }

  @media only screen and (min-device-width: 768px), (min-device-width: 1024px)
  and (max-device-width: 1024px), (max-device-width: 1366px)
  and (-webkit-min-device-pixel-ratio: 1), (-webkit-min-device-pixel-ratio: 2) {
    box-sizing: border-box;
    width: 100%;
    margin: auto auto 0 auto;
    height: auto;
  }

`;

export const ReTargetContentContainer = styled.div`
  overflow-y: auto;
  flex-grow: 0;
  margin: 0 0.5rem;
  padding: 0 1.5rem;
  ${(props) => props.isIOS && `
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
  `}
  @media screen and (min-width: ${breakpoints.tablet}) {
    width: 100%;
  }
  @media screen and (max-width: ${breakpoints.tablet}) and (min-width: ${breakpoints.mobile}) {
    height: ${(props) => (props.isDesktop ? '600px' : '550px')};
  }
  @media only screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    width: 90%;
  }
`;

export const Title = styled.h4`
  margin-bottom: 1rem;
  margin-top: 0;
  text-align: center;
  color: #313131;
  line-height: 1.3rem;
  font-size: 1.25rem;
  @media screen and (min-width: ${breakpoints.tablet}) {
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    width: 100%;
  }

  @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
    margin-left: 50%;
    transform: translate(-50%);
  }
  @media screen and (min-width: 500px) and (max-width: 500px) and (min-height: 530px) and (max-height: 530px) {
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    line-height: 1.5rem;
    font-size: 1.25rem;
  }

  @media only screen and (min-device-width: 768px),
    (min-device-width: 1024px) and (max-device-width: 1024px),
    (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1),
    (-webkit-min-device-pixel-ratio: 2) {
    text-align: ${(props) => (props.isDesktop ? (props.isRTL ? 'right' : 'left') : 'center')};
  }
`;

export const Body = styled.div`
  padding: 0;
  width: 100%;
  font-size: 1rem;
  line-height: 1.25;
  color: #4e4e4e;
  padding-bottom: 1rem;
  max-width: 34.5rem;
  text-align: center;
  margin: 0 auto;
  @media screen and (min-width: ${breakpoints.tablet}) {
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    max-width: 100%;
  }

  @media screen and (min-width: 500px) and (max-width: 500px) and (min-height: 530px) and (max-height: 530px) {
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    line-height: 1.25rem;
    font-size: 1rem;
  }

  @media only screen and (min-device-width: 768px),
    (min-device-width: 1024px) and (max-device-width: 1024px),
    (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1),
    (-webkit-min-device-pixel-ratio: 2) {
    text-align: ${(props) => (props.isDesktop ? (props.isRTL ? 'right' : 'left') : 'center')};
    max-width: ${(props) => (props.isDesktop ? '100%' : '34.5rem')};
  }
  && {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }

    p,
    > span > p {
      > a {
        color: #027aae;
        text-decoration: ${(props) => (props.isWJA ? 'none' : 'underline')};
        :hover {
          color: #006691;
        }
        :active {
          color: #004f74;
        }
      }
    }
  }
`;

export const Footer = styled.span`
  @media screen and (min-width: ${breakpoints.tablet}) {
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    width: 100%;
  }
  @media screen and (max-width: ${breakpoints.tablet}) {
    text-align: center;
  }
  @media only screen and (min-device-width: 768px),
    (min-device-width: 1024px) and (max-device-width: 1024px),
    (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1),
    (-webkit-min-device-pixel-ratio: 2) {
    text-align: ${(props) => (props.isDesktop ? (props.isRTL ? 'right' : 'left') : 'center')};
  }
  > p {
    > a {
      color: #027aae;
    }
  }
`;

export const ToggleLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  max-width: 34.5rem;
  margin: 0 auto;

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 100%;
  }
  @media screen and (min-width: 500px) and (max-width: 500px) and (min-height: 530px) and (max-height: 530px) {
    line-height: 1.25rem;
    font-size: 1rem;
  }

  @media only screen and (min-device-width: 768px),
    (min-device-width: 1024px) and (max-device-width: 1024px),
    (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1),
    (-webkit-min-device-pixel-ratio: 2) {
    max-width: ${(props) => (props.isDesktop ? '100%' : '34.5rem')};
  }
`;

export const StyledAccordion = styled(Accordion)`
  & > div {
    ${(props) => (props.isWJA && 'border-color: transparent;')};
    & > div:first-of-type:focus {
      outline: none;
    }
  }
`;

export const Graphic = styled.img`
  width: auto;
`;

export const ToggleLabelHeader = styled.label`
  font-size: 1rem;
  line-height: 1.25rem;
  margin-right: 0.5rem;
`;
export const ToggleLabelText = styled.div`
  display: inline;
  padding: 0.5rem 0;
  font-size: 0.875rem;
  line-height: 1.125rem;
`;

export const StyledButton = styled(Button)`
  @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
    margin-left: 50%;
    transform: translate(-50%);
  }
  min-height: ${stylesIf('small', '2.25', '2.875')}rem;
  ${stylesIf('small', 'border-radius: 0.5rem;')}
  ${stylesIf(
    'hasBody',
    `
        @media screen and (min-width: 25.875rem) {
          margin-top: 1rem;
        }
      `
  )}
  @media screen and (min-width:500px) and (max-width:500px) and (min-height:530px ) and (max-height:530px) {
    padding-right: 1rem;
  }

  @media only screen and (min-device-width: 768px),
    (min-device-width: 1024px) and (max-device-width: 1024px),
    (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1),
    (-webkit-min-device-pixel-ratio: 2) {
    margin-top: 1rem;
  }
`;

export const ConsentsButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: 100%;
    margin-top: 5rem;
    justify-content: ${(props) => (props.isWJA ? '' : 'space-between')};
    padding-bottom: ${(props) => (props.isDesktop ? '3rem' : '1rem')};
  }

  & > button:first-of-type {
    margin-left: ${(props) => (props.isWJA ? '1.125rem' : '3.125rem')};
  }
  @media screen and (max-width: ${breakpoints.tablet}) {
    display: flex;
    padding-bottom: ${(props) => (props.isDesktop ? '3rem' : '1rem')};
    padding-top: 1rem;
    flex-direction: column;
    & > button:first-of-type {
      margin-left: 0;
      margin-bottom: 0.625rem;
    }
  }
  @media screen and (min-width: 500px) and (max-width: 500px) and (min-height: 530px) and (max-height: 530px) {
    flex-direction: row-reverse;
    justify-content: ${(props) => (props.isWJA ? '' : 'space-between')};
    width: 100%;
    align-items: center;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-bottom: 0;
    box-sizing: border-box;
    margin-top: 0.5rem;
    & > button:first-of-type {
      margin-bottom: 0;
    }
  }

  @media only screen and (min-device-width: 768px),
    (min-device-width: 1024px) and (max-device-width: 1024px),
    (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1),
    (-webkit-min-device-pixel-ratio: 2) {
    width: ${(props) => (props.isDesktop ? '100%' : 'auto')};
    flex-direction: ${(props) => (props.isDesktop ? 'row-reverse' : 'column')};
    justify-content: ${(props) => (props.isWJA ? '' : props.isDesktop ? 'space-between' : '')};

    & > button:first-of-type {
      margin-left: ${(props) => (props.isDesktop ? '3.125rem' : '0')};
      margin-bottom: ${(props) => (props.isDesktop ? '0' : '1rem')};
    }
  }
`;

export const WjaContainer = styled.div`
  margin: auto;
`;

export const WjaToggleHeader = styled.div`
  display: flex;
  font-size: 0.975rem;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const WjaToggleHeaderTitle = styled.p`
  margin: 5px 0 0 10px;
`;

export const WjaToggleBody = styled.div`
  margin-left: 35px;
`;

export const WjaToggleBodyExtens = styled.div`
  margin-top: 10px;
  font-size: 0.875rem;
  font-weight: bold;
`;

export const WjaToggleBodyExtensContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const WjaToggleBodyExtensContainerDesc = styled.p`
  text-align: left;
`;

export const WjaToggleBodyExtensContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const WjaToggleBodyExtensContainerButtonText = styled.p`
  padding: 5px 0 0 10px;
`;